document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("click", (e) => {

    const layer = e.target.closest(
      ".embroidery-text-layer, .embroidery-image-layer"
    );

    document
      .querySelectorAll(
        ".embroidery-text-layer,.embroidery-image-layer"
      )
      .forEach(el => {
        el.classList.remove("embroidery-selected");
      });

    if (layer) {
      layer.classList.add(
        "embroidery-selected"
      );
    }

  });

});


/* =========================
   PREVIEW EXPORT ENGINE
========================= */

window.EMBPreview = {

async generateCanvas() {

const baseImage =
document.querySelector(
".embroidery-base-image"
);

if(!baseImage)
throw new Error(
"Base image missing"
);

const canvas =
document.createElement("canvas");

canvas.width =
baseImage.naturalWidth;

canvas.height =
baseImage.naturalHeight;

const ctx =
canvas.getContext("2d");

ctx.drawImage(
baseImage,
0,
0,
canvas.width,
canvas.height
);

const overlayCanvas =
await html2canvas(
  document.querySelector(
    "#embroideryCanvas"
  ),
  {
    backgroundColor: null,
    useCORS: true,
    allowTaint: true,
    scale: 1
  }
);

ctx.drawImage(
  overlayCanvas,
  0,
  0,
  canvas.width,
  canvas.height
);

return canvas;

}

};